import { FieldProps, getIn } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import { BaseArea, IBaseAreaProps } from '../../area';
import * as S from './area.styles';

type AreaFieldProps = IBaseAreaProps & FieldProps;

/**
 * Wrapper around AreaField to be able to work with Form components
 */
export const AreaField = React.memo<AreaFieldProps>(props => {
    const {
        field: { name, onBlur, onChange, value: fieldValue },
        form: { errors, touched: formTouched },
        placeholder,
        ...otherProps
    } = props;

    const [stateValue, setStateValue] = React.useState(fieldValue);
    const error = getIn(errors, name);
    const touched = getIn(formTouched, name);

    const errorMessage: string | undefined = touched && error ? error : undefined;

    // Update value if new fieldValue passed
    React.useEffect(() => {
        setStateValue(fieldValue);
    }, [fieldValue]);

    const value = _.isNil(stateValue) ? '' : stateValue; // avoid null or undefined values

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setStateValue(e.target.value);
    };

    const handleBlur = (e: React.ChangeEvent<any>): void => {
        onBlur(e); // To set 'touched'
        onChange(e);
    };

    return (
        <S.Container>
            <BaseArea
                value={value}
                placeholder={placeholder}
                rows={4}
                {...otherProps}
                // errorMessage={errorMessage}
                onChange={handleChange} // Manually trigger onchange only on blue for solving performance issues
                name={name}
                onBlur={handleBlur}
            />
        </S.Container>
    );
});
